import Vue from 'vue'
import gql from 'graphql-tag'
import { Component } from 'vue-property-decorator'

import AppDialog from '@/components/AppDialog.vue'
import { Vehicle } from '@/modules/Vehicle/interfaces/vehicle'
import { SnackType } from '@/interfaces/snack'
import { showErrors, showNotification } from '@/utils/snack'

import VehicleForm from '@/modules/Vehicle/components/VehicleForm.vue'
import { deleteVehicle } from '@/modules/Vehicle/gql/vehicle.gql'

@Component({
  components: {
    VehicleForm,
    AppDialog
  }
})
export default class VehicleDialog extends Vue {
  targetVehicle: Vehicle | null = null

  vehicleDialog = {
    actionType: 'new',
    show: false,
    title: 'New Vehicle',
    disable: false
  }

  deleteVehicleDialog = {
    show: false,
    title: 'Delete Vehicle',
    text: ''
  }

  showVehicleEditDialog (e: Event, targetVehicle?: Vehicle) {
    e.preventDefault()
    e.stopPropagation()
    let actionType = 'new'
    let title = 'New Vehicle'
    if (targetVehicle) {
      this.targetVehicle = targetVehicle
      actionType = 'edit'
      title = 'Edit Vehicle'
    }
    this.vehicleDialog = {
      actionType,
      show: true,
      title,
      disable: false
    }
  }

  hideVehicleEditDialog () {
    this.targetVehicle = null
    this.vehicleDialog = {
      actionType: 'new',
      show: false,
      title: 'New Vehicle',
      disable: false
    }
  }

  async deleteVehicle (e: Event, vehicle: Vehicle) {
    e.preventDefault()
    e.stopPropagation()
    this.targetVehicle = vehicle
    this.deleteVehicleDialog.show = true
  }

  async deleteVehiclePost () {
    if (!this.targetVehicle) {
      return
    }
    const { id } = this.targetVehicle
    this.deleteVehicleDialog.show = false
    try {
      const result = await this.$apollo.mutate({
        mutation: deleteVehicle,
        variables: {
          vehicleId: Number(id)
        }
      })

      const res = result.data.deleteVehicle
      if (res) {
        showNotification({
          msg: 'Delete vehicle successfully',
          type: SnackType.Success
        })
        this.targetVehicle = null
      }
    } catch (error) {
      showErrors(error.graphQLErrors)
    }
  }
}
